import { Controller } from "@hotwired/stimulus"

// Handles mobile <select> navigation for link-based tabs.
// When the user selects an option, navigates to the option's value (URL).
export default class extends Controller {
  navigate() {
    const url = this.element.value
    if (url) {
      window.location.href = url
    }
  }
}
